export function removeSubstring(originalString: string, substringToRemove: string): string {
    return originalString.replace(new RegExp(substringToRemove, 'g'), '');
}
